import {
  Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import DefectPage from 'src/components/DefectPage';
import { checkHizmet } from 'src/utils/storage/Defect';
import { checkIscilik } from 'src/utils/storage/Labour';
import { checkMalzeme } from 'src/utils/storage/Material';

import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import {
  addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';

const useStyles = makeStyles((theme) => ({
  root: {},
  contentH: {
    minHeight: 430,
  },
}));

function Hizmet({
  className, ReceiptNo, readonly, tasks, resetDefects, resetLabours, resetMaterials, defectReducer, labourReducer, materialReducer,
  getDefectRequest, getLabourRequest, getMaterialRequest, addDefects, addLabours, addMaterials
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const isOnline = useSelector((state) => state.status?.isOnline);
  const HizmetData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  let garantiTipi = 0;
  let garantiTipiText = '';
  let kulModelKodu = '';
  let Uyil = '';
  let Udonem = '';
  let SeriNo = '';
  let Barcode = '';
  let Model = '';
  if (HizmetData.length > 0) {
    garantiTipi = HizmetData[0].WarrantyTypeId || 1;
    garantiTipiText = HizmetData[0].WarrantyTypeText || '';
    kulModelKodu = HizmetData[0].ModelCode || '';
    Uyil = HizmetData[0].ProductionYear || '';
    Udonem = HizmetData[0].ProductionMonth || '';
    SeriNo = HizmetData[0].SerialNumber || '';
    Barcode = HizmetData[0].Barcode || '';
    Model = HizmetData[0].Model || '';
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (readonly) {
      return;
    }
    const kulmodelkodu = loadBaslandiJob()[0].ModelCode;
    const uyil = loadBaslandiJob()[0].ProductionYear || 0;
    const udonem = loadBaslandiJob()[0].ProductionMonth || 0;
    const WorkOrderIdParam = loadBaslandiJob()[0].ReceiptNo || 0;

    if (defectReducer.Data.length === 0) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1);
    }
    if (materialReducer.Data.length === 0) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem, WorkOrderIdParam);
    }
    if (labourReducer.Data === 0) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1, WorkOrderIdParam);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (readonly) {
      return;
    }
    const kulmodelkodu = loadBaslandiJob()[0].ModelCode;
    const uyil = loadBaslandiJob()[0].ProductionYear;
    const udonem = loadBaslandiJob()[0].ProductionMonth;
    const WorkOrderIdParam = loadBaslandiJob()[0].ReceiptNo || 0;

    if (!checkHizmet(kulmodelkodu)) {
      resetDefects();
      getDefectRequest(kulmodelkodu, 1);
    }
    if (!checkMalzeme(kulmodelkodu)) {
      resetMaterials();
      getMaterialRequest(kulmodelkodu, 1, 1, uyil, udonem, WorkOrderIdParam);
    }
    if (!checkIscilik(kulmodelkodu)) {
      resetLabours();
      getLabourRequest(kulmodelkodu, 1, 1, WorkOrderIdParam);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (readonly) {
      return;
    }
    const merkez = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
    const local = loadBaslandiJob();
    if (merkez[0].ModelCode === local[0].ModelCode) {
      if (merkez[0].WorkOrderDetails !== undefined) {
        if (merkez[0].WorkOrderDetails.length > 0 && local[0].WorkOrderDetails.length === 0) {
          setUyari(t('hizmet_tekrar_alma'));
          setOpen(true);
          resetDefects();
          resetMaterials();
          resetLabours();
          getDefectRequest(merkez[0].ModelCode, 1);
          getMaterialRequest(merkez[0].ModelCode, 1, 1, merkez[0].ProductionYear || 0, merkez[0].ProductionMonth || 0, merkez[0].ReceiptNo || 0);
          getLabourRequest(merkez[0].ModelCode, 1, 1, merkez[0].ReceiptNo || 0);
          const curr = merkez[0];
          if (curr.WorkOrderDetails) {
            const selectedDefects = [];
            let laboursHizmet = {};
            let materialsHizmet = {};
            curr.WorkOrderDetails.forEach((h, index) => {
              selectedDefects.push(h.DefectId);
              laboursHizmet = { ...laboursHizmet, [h.DefectId]: [] };
              materialsHizmet = { ...materialsHizmet, [h.DefectId]: [] };
            });
            addDefects(selectedDefects);
            if (curr.WorkOrderLabours) {
              curr.WorkOrderLabours.forEach((i, index) => {
                laboursHizmet[i.DefectId].push(i.LabourCode.toString());
              });
              addLabours(laboursHizmet);
            }
            if (curr.WorkOrderMaterials) {
              curr.WorkOrderMaterials.forEach((i, index) => {
                materialsHizmet[i.DefectId].push(i.MaterialCode.toString());
                materialsHizmet = { ...materialsHizmet, [i.MaterialCode]: i.Count };
              });
              addMaterials(materialsHizmet);
            }
          }
        }
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loading) {
      localStorageKaydet();
    }
    // eslint-disable-next-line
  }, [defectReducer, materialReducer, labourReducer]);

  const localStorageKaydet = () => {
    if (readonly) {
      return;
    }
    if (defectReducer.Data.length === 0) {
      return;
    }
    let job = loadBaslandiJob()[0];
    const hizmetlerH = [];
    const isciliklerH = [];
    const malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        DefectId: hizmet,
        DefectCode: hizmetRedux?.UserCode,
        DefectDesc: hizmetRedux?.DefectDesc,
        // TIP: hizmetRedux?.DefectType,
        // TIP_KODU: hizmetRedux?.DefectTypeCode,
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter((d) => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerH.push({
              LabourId: iscilik.LabourId,
              DefectId: hizmet,
              LabourCode: iscilik.LabourCode,
              LabourDesc: iscilik.LabourDesc,
              Price: iscilik.Price,
              PriceWithWat: iscilik.PriceWithWat,
              VatRate: iscilik.VatRate,
              VatId: iscilik.VatId,
              LabourPriceListId: parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceListIdWithoutWarranty : iscilik.PriceListId,
              LabourPriceId: iscilik.PriceId
            });
            iscilik_toplam += parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceWithoutWarranty : iscilik.Price;
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter((d) => d.MaterialCode === materialArray[m])[0];
          if (malzeme) {
            malzemelerH.push({
              MaterialId: malzeme.MaterialId,
              DefectId: hizmet,
              DefectDesc: hizmetRedux?.CategoryLevel1 + "/" + hizmetRedux?.CategoryLevel2 + "/" + hizmetRedux?.UserCode + "/" + hizmetRedux?.DefectDesc,
              MaterialCode: malzeme.MaterialCode,
              Count: materialReducer[malzeme.MaterialCode],
              MaterialDesc: malzeme.MaterialDesc,
              Price: malzeme.Price,
              PriceWithWat: malzeme.PriceWithWat,
              VatRate: malzeme.VatRate,
              VatId: malzeme.VatId,
              MaterialPriceListId: malzeme.PriceListId,
              MaterialPriceId: malzeme.PriceId
            });
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      WorkOrderDetails: hizmetlerH,
      WorkOrderLabours: isciliklerH,
      WorkOrderMaterials: malzemelerH,
      EMploymentCostTotal: iscilik_toplam,
      MaterialTotal: malzeme_toplam,
    };
    saveBaslandiJob(job);
  };
  if (HizmetData[0].ModelCode === undefined || HizmetData[0].ModelCode === '' || HizmetData[0].ModelCode === null) {
    return (
      <Card>
        <CardHeader title={t('Urun_Kontrolu')} />
        <Divider />
        <CardContent className={classes.contentH}>
          {t('Urun_sec_mesaji')}
        </CardContent>
      </Card>
    );
  }

  const loading = defectReducer.loading || materialReducer.loading || labourReducer.loading;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {
        loading
          ? (
            <CircularProgress
              status="loading"
              style={{ marginLeft: '50%' }}
            />
          )
          : (defectReducer.Data.length === 0 && !window.navigator.onLine ? (
            <Card>
              <CardHeader title={t('Offline_Title')} />
              <Divider />
              <CardContent className={classes.contentH}>
                {t('Offline_Message')}
              </CardContent>
            </Card>
          )
            : (
              <DefectPage
                ReceiptNo={ReceiptNo}
                garantiTipi={garantiTipi}
                garantiTipiText={garantiTipiText}
                readonly={readonly}
                kulModelKodu={kulModelKodu}
                Uyil={Uyil}
                Udonem={Udonem}
                SeriNo={SeriNo}
                Barcode={Barcode}
                Model={Model}
                resetLabours={resetLabours}
                resetMaterials={resetMaterials}
                resetDefects={resetDefects}
                getDefectRequest={getDefectRequest}
                getMaterialRequest={getMaterialRequest}
                getLabourRequest={getLabourRequest}
              />
            )
          )
      }
    </div>
  );
}

Hizmet.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
    resetDefects: state.resetDefects,
    resetLabours: state.resetLabours,
    resetMaterials: state.resetMaterials,
  }), {
  resetDefects, resetLabours, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest, addDefects, addLabours, addMaterials
}
)(Hizmet);
